/* Fight Trade · Bangkok Light product page helpers (loaded on product templates only):
   1. Layout: description, glove weight guide, store promises and "Pairs well with" move from the buy column into a
      two-column area under the white buy panel (see fight-trade-a.css "PDP panel").
   2. Gallery = thumbnails on the left + ONE large photo (desktop, >= 768px).
   Yuva's "List" (stacked) gallery shows every photo one under another and a thumbnail click scrolls to it.
   Here only the active photo is shown; a thumbnail click (also the one Yuva fires itself when a variant changes)
   swaps the large photo instead of scrolling. Phones keep Yuva's swipe row. Loaded (defer) on product templates only. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 768px)');

  function galleries() {
    return Array.prototype.filter.call(document.querySelectorAll('.yv-product-gallery-slider'), function (g) {
      /* stacked gallery only: the grid style carries .gallery-style, the carousel has no .yv-product-gallery-items */
      return !g.classList.contains('gallery-style') && g.querySelector('.yv-product-gallery-items .gallery-main-item');
    });
  }

  function show(gallery, mediaId) {
    var items = gallery.querySelectorAll('.gallery-main-item');
    var target = mediaId ? gallery.querySelector('.gallery-main-item#' + CSS.escape(mediaId)) : null;
    if (!target) target = items[0];
    if (!target) return;
    Array.prototype.forEach.call(items, function (item) {
      item.classList.toggle('ft-active', item === target);
    });
    Array.prototype.forEach.call(gallery.querySelectorAll('.gallery-thumbs-item'), function (thumb) {
      thumb.classList.toggle('active', thumb.getAttribute('data-image') === target.id);
    });
  }

  function init() {
    galleries().forEach(function (gallery) {
      gallery.classList.add('ft-one-media');
      if (gallery.querySelector('.gallery-main-item.ft-active')) return;
      var activeThumb = gallery.querySelector('.gallery-thumbs-item.active');
      show(gallery, activeThumb ? activeThumb.getAttribute('data-image') : null);
    });
  }

  /* capture phase: runs before Yuva's own click handler, which would scroll the page */
  document.addEventListener('click', function (e) {
    if (!MQ.matches) return;
    var thumb = e.target.closest ? e.target.closest('.gallery-thumbs-item') : null;
    if (!thumb) return;
    var gallery = thumb.closest('.yv-product-gallery-slider.ft-one-media');
    if (!gallery) return;
    e.preventDefault();
    e.stopPropagation();
    show(gallery, thumb.getAttribute('data-image'));
  }, true);

  /* ---------- Layout: the extra info goes under the buy panel, in two columns ----------
     Moved nodes stay inside <product-info>, so Yuva keeps updating them on variant change
     (the weight guide's "fits" marks follow the selected weight). */
  var KINDS = [
    { key: 'desc', where: 'main', find: function (col) { return col.querySelector(':scope > .yv-product-accordion'); } },
    { key: 'guide', where: 'side', find: function (col) {
      return Array.prototype.find.call(col.querySelectorAll(':scope > .product_custom_liquid'), function (el) { return el.querySelector('.ft-oz'); });
    } },
    { key: 'badges', where: 'side', find: function (col) { return col.querySelector(':scope > .product-services-badges'); } },
    { key: 'pairs', where: 'side', find: function (col) { return col.querySelector(':scope > .complementary_products'); } }
  ];

  function layout() {
    Array.prototype.forEach.call(document.querySelectorAll('product-info'), function (info) {
      var section = info.querySelector('.yv_product_content_section');
      var col = info.querySelector('.yv-main-product-detail');
      if (!section || !col) return;
      var more = section.querySelector(':scope > .ft-pdp-more');
      if (!more) {
        more = document.createElement('div');
        more.className = 'ft-pdp-more';
        var main = document.createElement('div');
        main.className = 'ft-pdp-more__main';
        var side = document.createElement('div');
        side.className = 'ft-pdp-more__side';
        more.appendChild(main);
        more.appendChild(side);
        section.appendChild(more);
      }
      KINDS.forEach(function (kind) {
        var node = kind.find(col);
        if (!node) return;
        /* a re-rendered column brings a fresh copy: replace the old one */
        var old = more.querySelector('[data-ft-kind="' + kind.key + '"]');
        if (old && old !== node) old.remove();
        node.setAttribute('data-ft-kind', kind.key);
        more.querySelector('.ft-pdp-more__' + kind.where).appendChild(node);
      });
      /* quantity stepper on the price line, to the right of the price */
      var price = col.querySelector(':scope > .yv-pricebox-outer, :scope > .ft-price-row > .yv-pricebox-outer');
      var qty = col.querySelector(':scope > .product-quantity-wrapper .yv-product-quantity');
      if (price && qty) {
        var row = col.querySelector(':scope > .ft-price-row');
        if (!row) {
          row = document.createElement('div');
          row.className = 'ft-price-row';
          price.parentNode.insertBefore(row, price);
        }
        if (price.parentNode !== row) row.insertBefore(price, row.firstChild);
        var oldQty = row.querySelector(':scope > .yv-product-quantity');
        if (oldQty && oldQty !== qty) oldQty.remove();
        row.appendChild(qty);
      }

      more.classList.toggle('ft-pdp-more--no-main', !more.querySelector('.ft-pdp-more__main > *'));
      more.classList.toggle('ft-pdp-more--no-side', !more.querySelector('.ft-pdp-more__side > *'));
      more.hidden = !more.querySelector('.ft-pdp-more__main > *, .ft-pdp-more__side > *');
    });
  }

  /* Yuva swaps the gallery markup on some variant changes: re-apply */
  var observer = new MutationObserver(function () {
    window.clearTimeout(observer.t);
    observer.t = window.setTimeout(function () {
      init();
      layout();
    }, 50);
  });

  function start() {
    layout();
    init();
    Array.prototype.forEach.call(document.querySelectorAll('product-info, .product-section'), function (root) {
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
